import undefinity from "../../common/helpers/undefinity";
import Measure from "../../api/types/Measure";

export default function normalizeMeasure(measure: Measure) {
    return {
        measures: {
            [measure.id]: undefinity({...measure})
        }
    }
}